export enum RecipientExpansionStatus {
    None,
    InProgress,
    Failed,
    SucceededWithDLOrGroupMembers,
    SucceededWithoutDLOrGroupMembers,
}
